import React, { useState, useEffect } from 'react';
import { Shield, ChevronLeft, ChevronRight } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';

export default function AuditPage() {
  const { api } = useAuth();
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);

  useEffect(() => {
    api('get', `/api/admin/audit?page=${page}`).then(r => { setLogs(r.data.logs || []); setTotal(r.data.total || 0); }).catch(console.error);
  }, [page]);

  const ACTION_COLORS = { login: 'text-blue-400', client_created: 'text-green-400', onboarding_complete: 'text-[#D4A017]', contract_created: 'text-purple-400' };

  return (
    <div className="max-w-5xl">
      <h1 className="text-2xl font-bold text-white mb-6">Audit Log</h1>
      <div className="bg-[#0f172a] rounded-2xl border border-white/5 overflow-hidden">
        <div className="grid grid-cols-4 text-xs font-bold text-[#475569] uppercase px-5 py-3 border-b border-white/5">
          <span>Actie</span><span>Gebruiker</span><span>Resource</span><span>Tijdstip</span>
        </div>
        {logs.length === 0 ? (
          <div className="py-12 text-center">
            <Shield className="w-10 h-10 text-[#475569] mx-auto mb-3" />
            <p className="text-[#475569]">Geen audit logs</p>
          </div>
        ) : logs.map((l, i) => (
          <div key={i} className="grid grid-cols-4 items-center px-5 py-3 border-b border-white/5 last:border-0 hover:bg-white/5 transition-all">
            <span className={`text-sm font-medium ${ACTION_COLORS[l.action] || 'text-[#94a3b8]'}`}>{l.action}</span>
            <span className="text-[#64748b] text-sm truncate">{l.user_id?.slice(0, 8)}...</span>
            <span className="text-[#475569] text-sm truncate">{l.details || l.resource?.slice(0, 8) || '-'}</span>
            <span className="text-[#475569] text-sm">{l.timestamp?.slice(0, 16)}</span>
          </div>
        ))}
      </div>
      {total > 50 && (
        <div className="flex items-center justify-center gap-4 mt-4">
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="p-2 text-[#64748b] hover:text-white disabled:opacity-30"><ChevronLeft size={20} /></button>
          <span className="text-[#64748b] text-sm">Pagina {page} van {Math.ceil(total / 50)}</span>
          <button onClick={() => setPage(p => p + 1)} disabled={page >= Math.ceil(total / 50)} className="p-2 text-[#64748b] hover:text-white disabled:opacity-30"><ChevronRight size={20} /></button>
        </div>
      )}
    </div>
  );
}
